import React, { FunctionComponent } from "react";
import Button from "react-bootstrap/Button";
import YaraEditorWrapper from "../../../yara/yara_editor/YaraEditorWrapper";
import useModal from "../../../../hooks/useModal";

interface IOpenRulesetButton {
  selectedRulesetId?: number | null;
}

const OpenRulesetButton: FunctionComponent<IOpenRulesetButton> = ({
  selectedRulesetId
}) => {
  const [editModalShow, , editModalToggle] = useModal();

  return (
    <>
      <Button
        variant="link"
        data-testid="yara_toolbar_open_ruleset"
        style={{ color: "#0057FF" }}
        disabled={selectedRulesetId == null}
        onClick={editModalToggle}
      >
        Open Ruleset
      </Button>

      {editModalShow && (
        <YaraEditorWrapper
          id={selectedRulesetId}
          show
          onClose={editModalToggle}
        />
      )}
    </>
  );
};

export default OpenRulesetButton;
